"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
const DropdownMenuItem = _ref => {
  let {
    id,
    className,
    children,
    onClick
  } = _ref;
  const onItemClick = event => {
    if ((0, _ark.isFunction)(onClick)) onClick(event);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    role: "button",
    tabIndex: 0,
    className: (0, _arkReact.concatClassName)('dropdownMenuItem', className),
    onClick: onItemClick
  }, children);
};
process.env.NODE_ENV !== "production" ? DropdownMenuItem.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func
} : void 0;
DropdownMenuItem.defaultProps = {
  id: undefined,
  className: undefined,
  children: undefined,
  onClick: undefined
};
var _default = exports.default = DropdownMenuItem;